




















































































































































































































































































import Vue from 'vue';
import {
  getDefaultPagerInfo,
  formatNumber
} from '@/utils/utils';
import { 
  Color,
  Flg,
} from '@/constants/constants';

export default Vue.extend<any, any, any, any>({
  name: 'G_070_HambaiYosokuConfirm_Table',
  props: {
    headerTitle: {
      type: Array,
      default: () => [],
    },
    items: Array,
    search: String,
    setSelectedItems: Function,
  },
  data: () => ({
    Color,
    Flg,
    footerProps: {},
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    selectedItems: [] as any,
  }),
  methods: {
    formatNumber,
    //----------------------------------------
    // 全解除
    //----------------------------------------
    uncheckAllCheckBoxs() {
      this.selectedItems = [];
    },
  },
  watch: {
    selectedItems: {
      handler(items: any) {
        this.setSelectedItems(items);
      },
    },
  },
  computed: {
    tableHeight() {
      return this.$vuetify.breakpoint.height - 380;
    },
    headers() {
      return [
        {
          text: '品目ｺｰﾄﾞ',
          value: 'himmokuCd',
          width: 100,
          sortable: true,
        },
        {
          text: '品目',
          value: 'himmokuMei',
          class: 'text-truncate',
          cellClass: 'text-truncate',
          width: 380,
          sortable: true,
        },
        {
          text: this.headerTitle[0],
          value: 'val1',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[1],
          value: 'val2',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[2],
          value: 'val3',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[3],
          value: 'val4',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[4],
          value: 'val5',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[5],
          value: 'val6',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[6],
          value: 'val7',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[7],
          value: 'val8',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[8],
          value: 'val9',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[9],
          value: 'val10',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[10],
          value: 'val11',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[11],
          value: 'val12',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[12],
          value: 'val13',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[13],
          value: 'val14',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[14],
          value: 'val15',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[15],
          value: 'val16',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[16],
          value: 'val17',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[17],
          value: 'val18',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[18],
          value: 'val19',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[19],
          value: 'val20',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[20],
          value: 'val21',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[21],
          value: 'val22',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[22],
          value: 'val23',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[23],
          value: 'val24',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[24],
          value: 'val25',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[25],
          value: 'val26',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[26],
          value: 'val27',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[27],
          value: 'val28',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[28],
          value: 'val29',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[29],
          value: 'val30',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[30],
          value: 'val31',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[31],
          value: 'val32',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[32],
          value: 'val33',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[33],
          value: 'val34',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[34],
          value: 'val35',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[35],
          value: 'val36',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[36],
          value: 'val37',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[37],
          value: 'val38',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[38],
          value: 'val39',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[39],
          value: 'val40',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[40],
          value: 'val41',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[41],
          value: 'val42',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[42],
          value: 'val43',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[43],
          value: 'val44',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[44],
          value: 'val45',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[45],
          value: 'val46',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[46],
          value: 'val47',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
        {
          text: this.headerTitle[47],
          value: 'val48',
          width: 100,
          sortable: false,
          class: 'text-end',
          cellClass: 'text-end',
        },
      ]
      .filter(item =>
          (item.value == "himmokuCd" ||
           item.value == "himmokuMei" ||
           Number(item.value.replace("val", "")) <= this.headerTitle.length)
      );
    },
  },
  created() {
  },
  mounted() {
    const pagerInfo = getDefaultPagerInfo();
    this.footerProps = pagerInfo.footerProps;
    this.options.itemsPerPage = pagerInfo.itemPerPage;
  },
});
